import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import { useDispatch } from 'react-redux'
import SupplyBillStatusSelect from './fields/SupplyBillStatusSelect'
import { editSupplyBillStatusAPI } from '../../../../../api/supply/supplyBillAPI'
import { setSupplyBill } from '../../../../../store/supplyBillSlice'

const ChangeStatusBillForm = ({ supplyBillBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(supplyBillBd ? {status: supplyBillBd.status} : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        editSupplyBillStatusAPI({
            supplyBillId: supplyBillBd.id, 
            status: data.status
        }).then(data => {
            dispatch(setSupplyBill(data))
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('status', 'supplyBill') ?
				<SupplyBillStatusSelect
					required={formDataProductRequiredField('status', 'supplyBill')}
					setValidate={e => updateValidate(setValid, 'status', e)}
					setValueForm={e => setValueForm(setData, 'status', e)}
					forciblyValue={data && data.status ? data.status : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeStatusBillForm